import { Box, Button, Flex, HoverCard, Stack, Text } from '@mantine/core'
import React from 'react'
import { OwnerAvatar } from './OwnerAvatar'
import { IconMessage } from '@tabler/icons'

const OwnerHoverCard = ({record, openActivity}: {record: any, openActivity: () => void}) => {
  return (
    <HoverCard withinPortal position='right'>
      <HoverCard.Target>
        <Stack justify='center' onClick={openActivity}>
          <OwnerAvatar data={record} />
        </Stack>
      </HoverCard.Target>
      <HoverCard.Dropdown style={{
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '8px',
        padding: '12px',
      }}>
        <Box
                    
        >
          <Flex>
            {record?.owner?.picture && <Box>
              <OwnerAvatar data={record} size={24} />
            </Box>}
            <Box ml={15}>
              <Text>Owner:</Text>
              <Text fw={600} mb={7}>{record?.owner?.name}</Text>
              <Button
                leftIcon={<IconMessage size={14}/>}
                styles={(theme) => ({
                  root: {
                    height: "32px",
                    backgroundColor: "#5C5CEB",
                    border: 0,
                    fontWeight: 400,
                    padding: "0px 5px",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  },
                  leftIcon: {
                    marginRight: 15,
                  },
                })}
                onClick={openActivity}
              >Message
              </Button>
            </Box>
          </Flex>
        </Box>
      </HoverCard.Dropdown>
    </HoverCard>
  )
}

export default OwnerHoverCard